import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BadgeIcon } from '@orobix/orobix-fe-components'
import i18n from 'i18next'

import { formatDateTime } from '../../../utils/date'

type DrugStatusIconProps = {
  machinable: boolean
  manualOverride: boolean
  manualOverrideBy: string | null
  manualOverrideAt: Date | null
}

// Combines the former "Macchinabile"/"Origine" columns into one compact
// icon. The primary signal (machinable) is always shown; the secondary one
// (manual override) only adds a badge for the exception, so the common
// "automatic" case stays visually quiet instead of repeating "Automatico"
// on every row.
export const DrugStatusIcon = ({
  machinable,
  manualOverride,
  manualOverrideBy,
  manualOverrideAt,
}: DrugStatusIconProps) => {
  const statusLabel = (
    machinable ? i18n.t('Machinable') : i18n.t('Not machinable')
  ) as string

  const manualLabel = manualOverrideBy
    ? `${i18n.t('Manual')} (${manualOverrideBy}${
        manualOverrideAt ? `, ${formatDateTime(manualOverrideAt)}` : ''
      })`
    : (i18n.t('Manual') as string)

  const originLabel = manualOverride
    ? manualLabel
    : (i18n.t('Automatic') as string)

  const title = `${statusLabel} · ${originLabel}`

  const icon = (
    <FontAwesomeIcon
      icon={machinable ? faCheckCircle : faTimesCircle}
      color={machinable ? '#2e7d32' : '#9e9e9e'}
    />
  )

  return (
    <span title={title}>
      {manualOverride ? (
        <BadgeIcon icon={icon} badge="M" color="warning" size="sm" />
      ) : (
        icon
      )}
    </span>
  )
}
